import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserInfo } from '../../services/payload/userInfo_pobj'

@Injectable({
  providedIn: 'root'
})
export class StmgService {

  // Meeting Data
  private meetingData = new BehaviorSubject<any>('');
  cast_meetingData = this.meetingData.asObservable();

  // Resalt View back button
  private clicked = new BehaviorSubject<any>('');
  cast_clickStatus = this.clicked.asObservable();

  // user info data
  private userInfo = new BehaviorSubject<UserInfo>(new UserInfo(""))
  userInfoObervable = this.userInfo.asObservable();

  // login data
  private loginInfo = new BehaviorSubject<any>('');
  loginInfoObervable = this.loginInfo.asObservable();

  // login status 
  private is_logged = new BehaviorSubject<boolean>(false);
  is_logged_status = this.is_logged.asObservable();

  // sport icons
  private sportIcons = new BehaviorSubject<any>('');
  cast_sportIcons = this.sportIcons.asObservable();

  // News Info
  private newsInfo = new BehaviorSubject<any>('');
  newsInfoObservable = this.newsInfo.asObservable();

  // Get Bank List
  private bankList = new BehaviorSubject<any>('');
  bankListObservable = this.bankList.asObservable();

  // Get branch List
  private branchList = new BehaviorSubject<any>('');
  bListObservable = this.branchList.asObservable();

  // Get news category List
  private newsCategories = new BehaviorSubject<any>('');
  newsCategoriesObservable = this.newsCategories.asObservable();

   // Selected news category
   private selectedCategory = new BehaviorSubject<any>('');
   selectedCategoryObservable = this.selectedCategory.asObservable();

   // Selected Bets
   private selectedBets = new BehaviorSubject<any>('');
   cast_selectedBets = this.selectedBets.asObservable();

  //selected language
  private language = new BehaviorSubject<any>('');
  language_status = this.language.asObservable();

  // next10Refresh
  private next10Refresh = new BehaviorSubject<any>('');
  next10Refresh_status = this.next10Refresh.asObservable();

  // allRaceRefresh
  private allRaceRefresh = new BehaviorSubject<any>('');
  allRaceRefresh_status = this.allRaceRefresh.asObservable();

  // sportRefresh
  private sportRefresh = new BehaviorSubject<any>('');
  sportRefresh_status = this.sportRefresh.asObservable();

  // inplayRefresh
  private inplayRefresh = new BehaviorSubject<any>('');
  inplayRefresh_status = this.inplayRefresh.asObservable();

  // vrRefresh
  private vrRefresh = new BehaviorSubject<any>('');
  vrRefresh_status = this.vrRefresh.asObservable();

  // nav2allRaceRefresh
  private nav2allRaceRefresh = new BehaviorSubject<any>('no');
  nav2allRaceRefresh_status = this.nav2allRaceRefresh.asObservable();

  // nav2next10Refresh
  private nav2next10Refresh = new BehaviorSubject<any>('no');
  nav2next10Refresh_status = this.nav2next10Refresh.asObservable();

  // nav2SportRefresh
  private nav2SportRefresh = new BehaviorSubject<any>('no');
  nav2SportRefresh_status = this.nav2SportRefresh.asObservable();

  // nav2InplayRefresh
  private nav2InplayRefresh = new BehaviorSubject<any>('no');
  nav2InplayRefresh_status = this.nav2InplayRefresh.asObservable();

  // nav2TracksideRefresh
  private nav2TracksideRefresh = new BehaviorSubject<any>('');
  nav2TracksideRefresh_status = this.nav2TracksideRefresh.asObservable();

  // latest version
  private version = new BehaviorSubject<any>('');
  version_status = this.version.asObservable();

   // homeBanners
   private homeBanners = new BehaviorSubject<any>('');
   homeBanners_obs = this.homeBanners.asObservable();

  constructor() { }

  updateMeetingData(d: any) {
    this.meetingData.next(d);
  }

  updateResultBackButton(d: any) {
    this.clicked.next(d);
  }

  updateUserInfo(d: UserInfo) {
    this.userInfo.next(d);
  }

  updateLoginData(d: any) {
    this.loginInfo.next(d);
  }

  updateLoginStatus(d: any) {
    this.is_logged.next(d);
  }

  updateSportIcons(d: any) {
    this.sportIcons.next(d);
  }

  updateNewsInfo(d: any) {
    this.newsInfo.next(d);
  }

  updateBankList(d: any) {
    this.bankList.next(d);
  }

  updateBranchList(d: any) {
    this.branchList.next(d);
  }

  updateNewsCategories(d: any) {
    this.newsCategories.next(d);
  }

  updateSelectedCategory(d: any) {
    this.selectedCategory.next(d);
  }

  // private isUsingGameBets: boolean = false;

  updateSelecteBets(d: any) {
    // Block if game bets are active and show alert
    // if (this.isUsingGameBets) {
    //   alert('You are currently using Game Bets. Please clear your selections first to use regular number bets.');
    //   console.warn('Cannot use updateSelecteBets while updateGameSelecteBets is active');
    //   return;
    // }
    this.selectedBets.next(d);
  }

  // updateGameSelecteBets(d: any) {
  //   this.isUsingGameBets = true;
  //   this.selectedBets.next(d);
  // }

  // Add method to reset the flag
  // resetBetMode() {
  //   this.isUsingGameBets = false;
  //   this.selectedBets.next([]);
  // }

  updatelanguage(d: any) {
    this.language.next(d);
  }

  updateNext10Refresh(d: any) {
    this.next10Refresh.next(d);
  }

  updateAllRaceRefresh(d: any) {
    this.allRaceRefresh.next(d);
  }

  updateSportRefresh(d: any) {
    this.sportRefresh.next(d);
  }

  updateInplayRefresh(d: any) {
    this.inplayRefresh.next(d);
  }

  updateVrRefresh(d: any) {
    this.vrRefresh.next(d);
  }

  nav2AllRaceRefresh(d: any) {
    this.nav2allRaceRefresh.next(d);
  }

  nav2Next10Refresh(d: any) {
    this.nav2next10Refresh.next(d);
  }

  nav2sportRefresh(d: any) {
    this.nav2SportRefresh.next(d);
  }

  nav2inplayRefresh(d: any) {
    this.nav2InplayRefresh.next(d);
  }

  nav2tracksideRefresh(d: any) {
    this.nav2TracksideRefresh.next(d);
  }

  updateVersion(d: any) {
    this.version.next(d);
  }
  
  updatehomeBanners(d: any) {
    this.homeBanners.next(d);
  }

  private headerBarSubject = new BehaviorSubject<any>(null);
  headerBar$ = this.headerBarSubject.asObservable();

  setHeaderBar(headerBar: any) {
    this.headerBarSubject.next(headerBar);
  }

  private showHomeElementsSubject = new BehaviorSubject<boolean>(true);
  showHomeElements$ = this.showHomeElementsSubject.asObservable();

  setShowHomeElements(show: boolean) {
    this.showHomeElementsSubject.next(show);
  }

  private inVirtualSectionSubject = new BehaviorSubject<boolean>(false);
  inVirtualSection$ = this.inVirtualSectionSubject.asObservable();

  setInVirtualSection(inVirtual: boolean){
    this.inVirtualSectionSubject.next(inVirtual);
  }

  private updateSelectionsSubject = new BehaviorSubject<any>(null)
  updateSelections$ = this.updateSelectionsSubject.asObservable();

  updateSelections(selection:any){
    this.updateSelectionsSubject.next(selection);
  }

}
